// Urdu portal text. Product names continue to use the Arabic API field.
const trans_ur = {
  name: "نام",
  first_name: "پہلا نام",
  last_name: "آخری نام",
  name_ar: "اردو میں نام",
  name_en: "انگریزی میں نام",
  price: "قیمت",
  email: "ای میل",
  password: "پاس ورڈ",
  confirm_password: "پاس ورڈ کی تصدیق",
  phone_number: "فون نمبر",
  business_name: "کاروبار کا نام",
  business_type: "کاروبار کی قسم",
  shop_address: "دکان کا پتہ",
  cr_number: "تجارتی رجسٹریشن نمبر",
  vat_number: "ویلیو ایڈڈ ٹیکس نمبر",
  business_logo: "کاروبار کا لوگو",
  image: "تصویر",
  is_taxable: "قابلِ ٹیکس",
  is_refunded: "رقم واپس کی گئی",
  is_qr_product: "کیو آر پروڈکٹ",
  is_stockable: "اسٹاک میں شامل",
  reset: "دوبارہ ترتیب دیں",
  cart: "کارٹ",
  address: "پتہ",
  company: "کمپنی",
  individual: "فرد",
  code: "کوڈ",
  branch_code: "برانچ کوڈ",
  branch: "برانچ",
  active: "فعال",
  inactive: "غیر فعال",
  subscribe: "سبسکرائب کریں",
  unsubscribe: "سبسکرپشن ختم کریں",
  no_of_employees: "ملازمین کی تعداد",
  no_of_licenses: "لائسنس کی تعداد",
  vat_certificate: "ٹیکس سرٹیفکیٹ",
  cr_certificate: "تجارتی رجسٹریشن سرٹیفکیٹ",
  change: "تبدیل کریں",
  preview: "پیش منظر",
  save: "محفوظ کریں",
  add_license: "لائسنس شامل کریں",
  purchase_license: "لائسنس خریدیں",
  add_free_license: "مفت لائسنس شامل کریں",
  buy_more_license: "مزید لائسنس خریدیں!",
  buy_more_license_error: "مزید صارفین بنانے کے لیے مزید لائسنس خریدیں",
  buyer_company_name: "خریدار کمپنی کا نام",
  buyer_company_vat: "خریدار کمپنی کا ویلیو ایڈڈ ٹیکس نمبر",
  city: "شہر",
  region: "علاقہ",
  country: "ملک",
  postal_code: "پوسٹل کوڈ",
  description: "تفصیل",
  attachment: "منسلکہ",
  no_attachment: "کوئی منسلکہ نہیں",
  url: "یو آر ایل",
  secret_key: "خفیہ کلید",
  integration_type: "انضمام کی قسم",
  customer_name: "گاہک کا نام",
  vehicle_number: "گاڑی کا نمبر",
  vehicle_color: "گاڑی کا رنگ",
  reseller_number: "ری سیلر نمبر",
  type: "قسم",
  street: "گلی",
  building_number: "عمارت کا نمبر",
  plot_id_number: "پلاٹ کا شناختی نمبر",
  expiry_date: "میعاد ختم ہونے کی تاریخ",
  validate_preferred_contact_time_required: "رابطے کے لیے پسندیدہ وقت منتخب کریں۔",
  validate_email_required: "ای میل درج کرنا ضروری ہے۔",
  validate_email_invalid: "درست ای میل درج کریں۔",
  validate_password_required: "پاس ورڈ درج کرنا ضروری ہے۔",
  validate_password_min_characters: "پاس ورڈ میں کم از کم 6 حروف ہونے چاہییں۔",
  validate_password_confirm_not_matched: "تصدیقی پاس ورڈ مماثل نہیں ہے۔",
  validate_name_required: "نام درج کرنا ضروری ہے۔",
  validate_name_min_characters: "نام میں کم از کم 3 حروف ہونے چاہییں۔",
  validate_first_name_required: "پہلا نام درج کرنا ضروری ہے۔",
  validate_first_name_min_characters: "پہلے نام میں کم از کم 3 حروف ہونے چاہییں۔",
  validate_last_name_required: "آخری نام درج کرنا ضروری ہے۔",
  validate_last_name_min_characters: "آخری نام میں کم از کم 3 حروف ہونے چاہییں۔",
  validate_phone_required: "فون نمبر درج کرنا ضروری ہے۔",
  validate_phone_exact_limit: "فون نمبر میں ٹھیک 12 ہندسے ہونے چاہییں۔",
  validate_business_name_required: "کاروبار کا نام درج کرنا ضروری ہے۔",
  validate_business_type_required: "کاروبار کی قسم منتخب کریں۔",
  validate_cr_number_required: "تجارتی رجسٹریشن نمبر درج کرنا ضروری ہے۔",
  validate_cr_number_exact_limit: "تجارتی رجسٹریشن نمبر میں ٹھیک 10 ہندسے ہونے چاہییں۔",
  validate_vat_number_required: "ویلیو ایڈڈ ٹیکس نمبر درج کرنا ضروری ہے۔",
  validate_vat_number_exact_limit: "ویلیو ایڈڈ ٹیکس نمبر میں ٹھیک 15 ہندسے ہونے چاہییں۔",
  validate_city_required: "شہر درج کرنا ضروری ہے۔",
  validate_region_required: "علاقہ درج کرنا ضروری ہے۔",
  validate_country_required: "ملک درج کرنا ضروری ہے۔",
  validate_postal_code_required: "پوسٹل کوڈ درج کرنا ضروری ہے۔",
  validate_postal_code_5digits: "پوسٹل کوڈ میں ٹھیک 5 ہندسے ہونے چاہییں۔",
  validate_address: "پتہ درج کرنا ضروری ہے۔",
  validate_shop_address_required: "دکان کا پتہ درج کریں!",
  validate_image_file_type: "صرف JPG یا PNG فائل اپ لوڈ کی جا سکتی ہے!",
  validate_photo_file_type: "تصویر JPEG، PNG، JPG، GIF یا SVG فائل ہونی چاہیے!",
  validate_image_size: "تصویر کا حجم 2MB سے کم ہونا چاہیے!",
  validate_business_logo_required: "کاروبار کا لوگو ضروری ہے!",
  validate_image_pdf_file_type: "صرف JPG، PNG یا PDF فائل اپ لوڈ کی جا سکتی ہے!",
  validate_image_size_10: "تصویر کا حجم 10MB سے کم ہونا چاہیے!",
  validate_cr_certificate_required: "تجارتی رجسٹریشن سرٹیفکیٹ ضروری ہے!",
  validate_vat_certificate_required: "ٹیکس سرٹیفکیٹ ضروری ہے!",
  validate_type_required: "قسم منتخب کرنا ضروری ہے۔",
  validate_excel_file_type: "صرف ایکسل فائل اپ لوڈ کی جا سکتی ہے!",
  validate_file_size_1: "فائل کا حجم 1MB سے کم ہونا چاہیے!",
  validate_attachment_required: "منسلکہ شامل کرنا ضروری ہے!",
  validate_product_name_required: "پروڈکٹ کا نام درج کریں!",
  validate_product_price_required: "پروڈکٹ کی قیمت درج کریں!",
  validate_product_barcode_required: "پروڈکٹ کا بارکوڈ درج کریں!",
  validate_product_category_required: "پروڈکٹ کا زمرہ منتخب کریں!",
  validate_product_unit_required: "پروڈکٹ کی اکائی منتخب کریں!",
  validate_product_option_required: "پروڈکٹ کا اختیار منتخب کریں!",
  validate_address_required: "دکان کا پتہ درج کریں!",
  validate_branch_required: "برانچ منتخب کریں!",
  validate_description_required: "تفصیل درج کرنا ضروری ہے۔",
  validate_cash_required: "نقد رقم درج کرنا ضروری ہے۔",
  validate_card_required: "کارڈ کی رقم درج کرنا ضروری ہے۔",
  validate_reference_required: "حوالہ نمبر درج کرنا ضروری ہے۔",
  validate_discount_required: "رعایت کا فیصد درج کرنا ضروری ہے۔",
  validate_url_required: "یو آر ایل درج کرنا ضروری ہے۔",
  validate_url_invalid: "درج کردہ یو آر ایل درست نہیں ہے!",
  validate_secret_key_required: "خفیہ کلید درج کرنا ضروری ہے۔",
  validate_integration_type_required: "انضمام کی قسم منتخب کرنا ضروری ہے۔",
  validate_date_required: "تاریخ درج کرنا ضروری ہے۔",
  validate_customer_name_required: "گاہک کا نام درج کرنا ضروری ہے۔",
  validate_vehicle_number_required: "گاڑی کا نمبر درج کرنا ضروری ہے۔",
  validate_vehicle_color_required: "گاڑی کا رنگ درج کرنا ضروری ہے۔",
  validate_street_required: "گلی درج کرنا ضروری ہے۔",
  validate_building_number_required: "عمارت کا نمبر درج کرنا ضروری ہے۔",
  validate_plot_id_number_required: "پلاٹ کا شناختی نمبر درج کرنا ضروری ہے۔",
  validate_entity_required: "یہ خانہ پُر کرنا ضروری ہے۔",
  validate_value_required: "قدر درج کرنا ضروری ہے۔",
  validate_low_stock_required: "کم اسٹاک کی حد درج کرنا ضروری ہے۔",
  validate_expiry_date_required: "میعاد ختم ہونے کی تاریخ درج کرنا ضروری ہے۔",
  validate_calories_info_required: "کیلوریز کی معلومات درج کرنا ضروری ہے۔",
  validate_street_name_required: "گلی کا نام درج کرنا ضروری ہے۔",
  validate_building_number_4digits: "عمارت کے نمبر میں ٹھیک 4 ہندسے ہونے چاہییں۔",
  validate_plot_identification_required: "پلاٹ کا شناختی نمبر درج کرنا ضروری ہے۔",
  validate_plot_identification_4digits: "پلاٹ کے شناختی نمبر میں ٹھیک 4 ہندسے ہونے چاہییں۔",
  validate_district_required: "ضلع درج کرنا ضروری ہے۔",
  validate_environment_required: "ماحول منتخب کریں۔",
  validate_otp_required: "تصدیقی کوڈ درج کریں۔",
  validate_otp_6_digits: "تصدیقی کوڈ میں ٹھیک 6 ہندسے ہونے چاہییں۔",
  validate_buyer_company_name_required: "خریدار کمپنی کا نام درج کرنا ضروری ہے۔",
  validate_buyer_company_vat_required: "خریدار کمپنی کا ویلیو ایڈڈ ٹیکس نمبر درج کرنا ضروری ہے۔",
  validate_buyer_company_address_required: "خریدار کمپنی کا پتہ درج کرنا ضروری ہے۔",
  validate_arabic_name_required: "اردو نام درج کرنا ضروری ہے۔",
  validate_sa_vat_number: "ویلیو ایڈڈ ٹیکس نمبر 15 ہندسوں کا ہو اور 3 سے شروع اور ختم ہو۔",
  dont_have_account: "اکاؤنٹ نہیں ہے؟",
  login: "لاگ اِن",
  visit_website: "ویب سائٹ دیکھیں",
  website: "ویب سائٹ",
  already_have_an_account: "پہلے سے اکاؤنٹ ہے؟",
  sign_in: "سائن اِن",
  sign_up: "رجسٹر کریں",
  register_successfully: "آپ کی رجسٹریشن کامیابی سے مکمل ہو گئی!",
  selected_plan: "منتخب کردہ پلان",
  account_successfully_created: "آپ کا اکاؤنٹ کامیابی سے بن گیا!",
  details_activate_company: "کمپنی فعال کرنے کے لیے تفصیلات درج کریں یا فی الحال چھوڑ دیں۔",
  forgot: "پاس ورڈ بھول گئے؟",
  send_otp: "تصدیقی کوڈ بھیجیں",
  verify_otp: "تصدیقی کوڈ کی تصدیق کریں",
  reset_password: "پاس ورڈ دوبارہ ترتیب دیں",
  reset_password_successfully: "آپ کا پاس ورڈ کامیابی سے دوبارہ ترتیب دے دیا گیا!",
  daily: "روزانہ",
  trial: "آزمائشی مدت",
  opt_message: "آپ کے موبائل نمبر پر تصدیقی کوڈ بھیج دیا گیا ہے۔ اسے نیچے درج کریں اور تصدیق کریں۔",
  if_you_want_to_change_phone_number: "اگر آپ اپنا فون نمبر تبدیل کرنا چاہتے ہیں،",
  click_here: "یہاں کلک کریں",
  resend_code: "کوڈ دوبارہ بھیجیں",
  enable_in: "میں فعال کریں",
  validate: "تصدیق کریں",
  otp_sent_successfully: "تصدیقی کوڈ کامیابی سے بھیج دیا گیا!",
  otp_verified: "تصدیقی کوڈ کی تصدیق ہو گئی!",
  shop_configuration_successfully: "دکان کی ترتیب مکمل ہو گئی ہے۔",
  allow_round_off: "دو اعشاری ہندسوں تک گول کرنے کی اجازت دیں",
  preferred_contact_time: "رابطے کے لیے پسندیدہ وقت",
  home: "ہوم",
  pos: "پوائنٹ آف سیل",
  products_list: "مصنوعات کی فہرست",
  products: "مصنوعات",
  categories: "زمرے",
  units: "اکائیاں",
  options: "اختیارات",
  transactions: "لین دین",
  reports: "رپورٹس",
  sales_summary: "فروخت کا خلاصہ",
  sales_by_items: "مصنوعات کے لحاظ سے فروخت",
  sales_by_categories: "زمروں کے لحاظ سے فروخت",
  refunds_by_items: "مصنوعات کے لحاظ سے واپسی",
  refunds_by_categories: "زمروں کے لحاظ سے واپسی",
  report_by_branch: "برانچ کے لحاظ سے رپورٹ",
  store_configuration: "اسٹور کی ترتیبات",
  subscriptions: "سبسکرپشنز",
  branches: "برانچیں",
  orders: "آرڈرز",
  view_order: "آرڈر دیکھیں",
  edit_order: "آرڈر میں ترمیم کریں",
  tables: "میزیں",
  employees: "ملازمین",
  invoices: "انوائسز",
  help_desk: "مدد مرکز",
  discounts: "رعایتیں",
  external_integration: "بیرونی انضمام",
  addons: "اضافی سہولتیں",
  addon_detail: "اضافی سہولت کی تفصیل",
  inventory: "انوینٹری",
  stock: "اسٹاک",
  stock_overview: "اسٹاک کا جائزہ",
  stock_adjustment: "اسٹاک کی تبدیلی",
  view_stock_adjustment: "اسٹاک کی ایڈجسٹمنٹ دیکھیں",
  stock_transfer: "اسٹاک کی منتقلی",
  view_transfer: "منتقلی دیکھیں",
  edit_transfer: "منتقلی میں ترمیم کریں",
  customers: "گاہک",
  customer_details: "گاہک کی تفصیلات",
  sales_invoice: "فروخت کی انوائس",
  view_sales_invoice: "اے فور سیلز انوائس دیکھیں",
  tax_configuration: "ٹیکس کی ترتیبات",
  product_add: "مصنوعہ شامل کریں",
  product_added: "مصنوعہ شامل ہو گیا",
  product_added_successfully: "مصنوعہ کامیابی سے شامل ہو گیا۔",
  product_edit: "مصنوعے میں ترمیم کریں",
  product_updated: "مصنوعہ اپ ڈیٹ ہو گیا",
  product_updated_successfully: "مصنوعہ کامیابی سے اپ ڈیٹ ہو گیا۔",
  product_deleted: "مصنوعہ حذف ہو گیا",
  product_deleted_successfully: "پروڈکٹ کامیابی سے حذف ہو گئی!",
  products_import: "مصنوعات درآمد کریں",
  products_import_successfully: "پروڈکٹس کامیابی سے درآمد ہو گئے!",
  category_add: "زمرہ شامل کریں",
  category_name: "زمرے کا نام",
  category_edit: "زمرے میں ترمیم کریں",
  category_name_required: "پروڈکٹ کے زمرے کا نام درج کریں!",
  category_added: "زمرہ شامل کر دیا گیا",
  category_added_successfully: "زمرہ کامیابی سے شامل ہو گیا!",
  category_updated: "زمرہ اپ ڈیٹ ہو گیا",
  category_updated_successfully: "زمرہ کامیابی سے اپ ڈیٹ ہو گیا!",
  category_deleted: "زمرہ حذف کر دیا گیا",
  category_deleted_successfully: "زمرہ کامیابی سے حذف ہو گیا!",
  categories_import: "زمرے درآمد کریں",
  categories_import_successfully: "زمرے کامیابی سے درآمد ہو گئے!",
  unit_add: "اکائی شامل کریں",
  unit_name: "اکائی کا نام",
  unit_edit: "اکائی میں ترمیم کریں",
  unit_name_required: "پروڈکٹ کی اکائی کا نام درج کریں!",
  unit_added: "اکائی شامل کر دی گئی",
  unit_added_successfully: "اکائی کامیابی سے شامل ہو گئی!",
  unit_updated: "اکائی اپ ڈیٹ ہو گئی",
  unit_updated_successfully: "اکائی کامیابی سے اپ ڈیٹ ہو گئی!",
  unit_deleted: "اکائی حذف کر دی گئی",
  unit_deleted_successfully: "اکائی کامیابی سے حذف ہو گئی!",
  units_import: "اکائیاں درآمد کریں",
  units_import_successfully: "اکائیاں کامیابی سے درآمد ہو گئیں!",
  option_add: "اختیار شامل کریں",
  option_name: "اختیار کا نام",
  option_edit: "اختیار میں ترمیم کریں",
  option_name_required: "پروڈکٹ کے اختیار کا نام درج کریں!",
  option_added: "اختیار شامل کر دیا گیا",
  option_added_successfully: "اختیار کامیابی سے شامل ہو گیا!",
  option_updated: "اختیار اپ ڈیٹ ہو گیا",
  option_updated_successfully: "اختیار کامیابی سے اپ ڈیٹ ہو گیا!",
  option_deleted: "اختیار حذف کر دیا گیا",
  option_deleted_successfully: "اختیار کامیابی سے حذف ہو گیا!",
  select_options: "اختیارات منتخب کریں",
  branch_add: "برانچ شامل کریں",
  branch_added: "برانچ شامل کر دی گئی",
  branch_added_successfully: "برانچ کامیابی سے شامل ہو گئی!",
  branch_deleted: "برانچ حذف کر دی گئی",
  branch_deleted_successfully: "برانچ کامیابی سے حذف ہو گئی!",
  branch_edit: "برانچ میں ترمیم کریں",
  branch_updated: "برانچ اپ ڈیٹ ہو گئی",
  branch_updated_successfully: "برانچ کامیابی سے اپ ڈیٹ ہو گئی!",
  customer_add: "گاہک شامل کریں",
  customer_added: "گاہک شامل کر دیا گیا",
  customer_added_successfully: "گاہک کامیابی سے شامل ہو گیا!",
  customer_deleted: "گاہک حذف کر دیا گیا",
  customer_deleted_successfully: "گاہک کامیابی سے حذف ہو گیا!",
  customer_edit: "گاہک میں ترمیم کریں",
  customer_updated: "گاہک اپ ڈیٹ ہو گیا",
  customer_updated_successfully: "گاہک کامیابی سے اپ ڈیٹ ہو گیا!",
  mark_as_in_progress: "زیرِ عمل نشان زد کریں",
  mark_as_complete: "مکمل نشان زد کریں",
  add_order: "آرڈر شامل کریں",
  cancel_order: "آرڈر منسوخ کریں",
  order_added: "آرڈر شامل کر دیا گیا",
  order_added_successfully: "آرڈر کامیابی سے شامل ہو گیا!",
  order_updated: "آرڈر اپ ڈیٹ ہو گیا",
  order_updated_successfully: "آرڈر کامیابی سے اپ ڈیٹ ہو گیا!",
  table_added: "میز شامل ہو گئی",
  table_added_successfully: "میز کامیابی سے شامل ہو گئی!",
  drive_thru: "ڈرائیو تھرو",
  drive_thru_add: "ڈرائیو تھرو شامل کریں",
  drive_thru_added: "ڈرائیو تھرو شامل کر دیا گیا",
  drive_thru_added_successfully: "ڈرائیو تھرو کامیابی سے شامل ہو گیا!",
  entity_updated: "ادارہ اپ ڈیٹ ہو گیا",
  entity_updated_successfully: "ادارہ کامیابی سے اپ ڈیٹ ہو گیا!",
  entity_deleted: "ادارہ حذف کر دیا گیا",
  entity_deleted_successfully: "ادارہ کامیابی سے حذف ہو گیا!",
  add_table: "میز شامل کریں",
  update_table: "میز اپ ڈیٹ کریں",
  assign_table_to_order: "آرڈر کے لیے میز مختص کریں",
  select_table: "میز منتخب کریں",
  validate_table_required: "میز منتخب کرنا ضروری ہے۔",
  employee_add: "ملازم شامل کریں",
  employee_added: "ملازم شامل کر دیا گیا",
  employee_added_successfully: "ملازم کامیابی سے شامل ہو گیا!",
  employee_edit: "ملازم میں ترمیم کریں",
  employee_updated: "ملازم اپ ڈیٹ ہو گیا",
  employee_updated_successfully: "ملازم کامیابی سے اپ ڈیٹ ہو گیا!",
  employee_activate: "ملازم فعال کریں",
  employee_activated: "ملازم فعال ہو گیا",
  employee_activated_successfully: "ملازم کامیابی سے فعال ہو گیا!",
  employee_deactivate: "ملازم غیر فعال کریں",
  employee_deactivated: "ملازم غیر فعال ہو گیا",
  employee_deactivated_successfully: "ملازم کامیابی سے غیر فعال ہو گیا!",
  employee_deleted: "ملازم حذف کر دیا گیا",
  employee_deleted_successfully: "ملازم کامیابی سے حذف ہو گیا!",
  ticket_add: "ٹکٹ شامل کریں",
  ticket_added: "ٹکٹ شامل کر دیا گیا",
  ticket_added_successfully: "ٹکٹ کامیابی سے شامل ہو گیا!",
  ticket_updated: "ٹکٹ اپ ڈیٹ ہو گیا",
  ticket_updated_successfully: "ٹکٹ کامیابی سے اپ ڈیٹ ہو گیا!",
  discount_add: "رعایت شامل کریں",
  discount_added: "رعایت شامل کر دی گئی",
  discount_added_successfully: "رعایت کامیابی سے شامل ہو گئی!",
  discount_deleted: "رعایت حذف کر دی گئی",
  discount_deleted_successfully: "رعایت کامیابی سے حذف ہو گئی!",
  discount_edit: "رعایت میں ترمیم کریں",
  discount_updated: "رعایت اپ ڈیٹ ہو گئی",
  discount_updated_successfully: "رعایت کامیابی سے اپ ڈیٹ ہو گئی!",
  connection_add: "کنکشن شامل کریں",
  connection_update: "کنکشن اپ ڈیٹ کریں",
  connection_added: "کنکشن شامل کر دیا گیا",
  connection_added_successfully: "کنکشن کامیابی سے شامل ہو گیا!",
  connection_test: "کنکشن جانچیں",
  connection_tested_successfully: "کنکشن کی جانچ کامیاب رہی!",
  connection_tested_failed: "غلط اسناد کی وجہ سے کنکشن کی جانچ ناکام ہو گئی!",
  connection_save: "کنکشن محفوظ کریں",
  connection_saved_successfully: "کنکشن کامیابی سے محفوظ ہو گیا!",
  connection_saved_failed: "غلط اسناد کی وجہ سے کنکشن محفوظ نہیں ہو سکا!",
  connection_deleted: "کنکشن حذف کر دیا گیا",
  connection_deleted_successfully: "کنکشن کامیابی سے حذف ہو گیا!",
  addon_subscribed: "اضافی سہولت کی سبسکرپشن فعال ہو گئی",
  addon_subscribed_successfully: "اضافی سہولت کی سبسکرپشن کامیابی سے فعال ہو گئی!",
  addon_unsubscribed: "اضافی سہولت کی سبسکرپشن ختم ہو گئی",
  addon_unsubscribed_successfully: "اضافی سہولت کی سبسکرپشن کامیابی سے ختم ہو گئی!",
  subscribe_dependent_addons: "پہلے ان اضافی سہولتوں کو سبسکرائب کریں: {{addons}}",
  unsubscribe_dependency_warning: "اگر آپ {{addon}} کی سبسکرپشن ختم کرتے ہیں تو متعلقہ اضافی سہولتوں کی سبسکرپشن بھی خودکار طور پر ختم ہو سکتی ہے۔",
  addon_filter_all_modules: "تمام ماڈیولز",
  addon_available: "دستیاب",
  addon_requires: "درکار ہے",
  addon_used_by: "استعمال کنندہ",
  addon_whats_included: "کیا شامل ہے",
  addon_access: "رسائی",
  addon_daily_price_after_trial: "آزمائشی مدت کے بعد یومیہ قیمت",
  addon_available_with_current_setup: "موجودہ ترتیب کے ساتھ دستیاب",
  addon_charged_only_when_in_use: "اس سہولت کے استعمال پر ہی چارج کیا جائے گا",
  addon_always_on: "ہمیشہ فعال",
  addon_trial_days_label: "آزمائشی دن",
  addon_currently_active: "فی الحال فعال",
  addon_ready_to_activate: "فعال کرنے کے لیے تیار",
  addon_free_access: "مفت رسائی",
  addon_daily_billed_module: "یومیہ بل والا ماڈیول",
  addon_no_trial_period: "کوئی آزمائشی مدت نہیں",
  addon_required_addons_count: "{{count}} اضافی سہولت درکار ہے",
  addon_required_addons_count_other: "{{count}} اضافی سہولتیں درکار ہیں",
  addon_no_dependency_required: "کسی دوسری سہولت کی ضرورت نہیں",
  addon_used_by_addons_count: "{{count}} اضافی سہولت استعمال کرتی ہے",
  addon_used_by_addons_count_other: "{{count}} اضافی سہولتیں استعمال کرتی ہیں",
  addon_standalone_setup: "آزادانہ ترتیب",
  addon_free_trial_days: "{{days}} دن کی مفت آزمائش",
  addon_always_free: "ہمیشہ مفت",
  addon_no_trial_included: "آزمائش شامل نہیں",
  addon_per_day: "/ دن",
  no_addons_found: "کوئی اضافی سہولت نہیں ملی",
  model: "ماڈل",
  imei: "آئی ایم ای آئی",
  serial_no: "سیریل نمبر",
  due_amount: "واجب الادا رقم",
  installments: "اقساط",
  warranty_from_to: "وارنٹی کی مدت",
  warranty_starting_at: "وارنٹی شروع ہونے کی تاریخ",
  warranty_ending_at: "وارنٹی ختم ہونے کی تاریخ",
  user_licenses_added: "صارف کے لائسنس شامل کر دیے گئے",
  user_licenses_have_been_added_successfully: "صارف کے لائسنس کامیابی سے شامل ہو گئے!",
  wallet_details: "والٹ کی تفصیلات",
  available_credit: "دستیاب کریڈٹ",
  topup: "بیلنس بڑھائیں",
  balance_validity: "بیلنس کی میعاد",
  topup_request_received: "بیلنس بڑھانے کی درخواست موصول ہو گئی",
  topup_request_received_successfully: "بیلنس بڑھانے کی درخواست کامیابی سے موصول ہو گئی!",
  confirmation: "تصدیق",
  check_confirmation_checkbox: "تصدیقی خانہ منتخب کریں!",
  enter_topup_amount: "بیلنس میں شامل کرنے کی رقم درج کریں",
  enter_reference_no: "حوالہ نمبر درج کریں",
  minimum_topup_amount_required: "کم از کم رقم درج کرنا ضروری ہے",
  your_balance_is_low_please_recharge_minimum: "آپ کا بیلنس کم ہے۔ براہ کرم کم از کم مطلوبہ رقم شامل کریں۔",
  waiter: "ویٹر",
  add_waiter: "ویٹر شامل کریں",
  is_waiter: "ویٹر ہے",
  update_waiter: "ویٹر اپ ڈیٹ کریں",
  waiter_updated: "ویٹر اپ ڈیٹ ہو گیا",
  assign_waiter_to_order: "آرڈر کے لیے ویٹر مقرر کریں",
  select_waiter: "ویٹر منتخب کریں",
  validate_waiter_required: "ویٹر منتخب کرنا ضروری ہے۔",
  waiter_not_available_for_branch: "منتخب ویٹر اس برانچ کے لیے دستیاب نہیں ہے۔",
  no_waiter_found_for_branch: "اس برانچ کے لیے کوئی ویٹر نہیں ملا۔",
  job_person: "کام کرنے والا شخص",
  is_job_person: "کام کرنے والا شخص ہے",
  select_job_person: "کام کرنے والا شخص منتخب کریں",
  job_person_updated: "کام کرنے والا شخص اپ ڈیٹ ہو گیا",
  update_job_person: "کام کرنے والا شخص اپ ڈیٹ کریں",
  validate_job_person_required: "کام کرنے والا شخص منتخب کرنا ضروری ہے۔",
  adjustment_add: "ایڈجسٹمنٹ شامل کریں",
  stock_adjustment_done: "اسٹاک ایڈجسٹمنٹ مکمل ہو گئی",
  stock_adjustment_done_successfully: "اسٹاک ایڈجسٹمنٹ کامیابی سے مکمل ہو گئی!",
  adjustment_history: "ایڈجسٹمنٹ کی تاریخ",
  direct_transfer: "براہ راست منتقلی",
  request_transfer: "منتقلی کی درخواست کریں",
  cancel_transfer: "منتقلی منسوخ کریں",
  accept_transfer: "منتقلی قبول کریں",
  reject_transfer: "منتقلی مسترد کریں",
  confirm_transfer: "منتقلی کی تصدیق کریں",
  transfer_added: "منتقلی شامل کر دی گئی",
  transfer_added_successfully: "منتقلی کامیابی سے شامل ہو گئی!",
  transfer_updated: "منتقلی اپ ڈیٹ ہو گئی",
  transfer_updated_successfully: "منتقلی کامیابی سے اپ ڈیٹ ہو گئی!",
  invoice_add: "انوائس شامل کریں",
  invoice_added: "انوائس شامل کر دی گئی",
  invoice_added_successfully: "انوائس کامیابی سے شامل ہو گئی!",
  invoice_updated: "انوائس اپ ڈیٹ ہو گئی",
  invoice_updated_successfully: "انوائس کامیابی سے اپ ڈیٹ ہو گئی!",
  invoice_edit: "انوائس میں ترمیم کریں",
  invoice_deleted: "انوائس حذف کر دی گئی",
  invoice_deleted_successfully: "انوائس کامیابی سے حذف ہو گئی!",
  save_as_draft: "مسودے کے طور پر محفوظ کریں",
  issue_invoice: "انوائس جاری کریں",
  register_payment: "ادائیگی درج کریں",
  tax: "ٹیکس",
  tax_add: "ٹیکس شامل کریں",
  tax_added: "ٹیکس شامل کر دیا گیا",
  tax_added_successfully: "ٹیکس کامیابی سے شامل ہو گیا!",
  tax_updated: "ٹیکس اپ ڈیٹ ہو گیا",
  tax_updated_successfully: "ٹیکس کامیابی سے اپ ڈیٹ ہو گیا!",
  tax_edit: "ٹیکس میں ترمیم کریں",
  tax_deleted: "ٹیکس حذف کر دیا گیا",
  tax_deleted_successfully: "ٹیکس کامیابی سے حذف ہو گیا!",
  select_taxes: "ٹیکس منتخب کریں",
  tickets: "ٹکٹیں",
  is_ticket: "ٹکٹ ہے",
  issue_ticket: "ٹکٹ جاری کریں",
  print_ticket: "ٹکٹ پرنٹ کریں",
  ticket_issue_failed: "ٹکٹ جاری نہیں ہو سکا۔ دوبارہ کوشش کریں۔",
  no_unissued_ticket_found: "اس لین دین کے لیے کوئی غیر جاری شدہ ٹکٹ نہیں ملا۔",
  person_one: "شخص",
  person_other: "افراد",
  not_scanned: "اسکین نہیں ہوا",
  partially_scanned: "جزوی طور پر اسکین ہوا",
  fully_scanned: "مکمل اسکین ہوا",
  product: "مصنوعہ",
  category: "زمرہ",
  unit: "اکائی",
  option: "اختیار",
  barcode: "بار کوڈ",
  amount: "رقم",
  quantity: "مقدار",
  status: "حالت",
  created_at: "بنائے جانے کی تاریخ",
  created_by: "بنانے والا",
  paid_at: "ادائیگی کی تاریخ",
  subtotal: "ذیلی مجموعہ",
  sold_quantities: "فروخت شدہ مقداریں",
  gross_sales: "مجموعی فروخت",
  refund_quantities: "واپس کی گئی مقداریں",
  gross_refund: "مجموعی واپسی",
  start_date: "شروع کی تاریخ",
  end_date: "اختتام کی تاریخ",
  date: "تاریخ",
  subscription_plan: "سبسکرپشن پلان",
  transaction_id: "لین دین کا نمبر",
  discount_percentage: "رعایت کا فیصد",
  invoice_id: "انوائس آئی ڈی",
  subscription: "سبسکرپشن",
  license: "لائسنس",
  total_amount_charged: "وصول کردہ کل رقم",
  items: "اشیا",
  user: "صارف",
  payment: "ادائیگی",
  new: "نئے ٹکٹ",
  inprogress: "زیر عمل ٹکٹ",
  done: "مکمل ٹکٹ",
  closed: "بند ٹکٹ",
  allow_refund: "رقم کی واپسی کی اجازت دیں",
  allow_add_products: "پروڈکٹس شامل کرنے کی اجازت دیں",
  allow_edit_products: "پروڈکٹس میں ترمیم کی اجازت دیں",
  source: "ذریعہ",
  pending_orders: "زیرِ انتظار آرڈرز",
  inprogress_orders: "زیرِ عمل آرڈرز",
  completed_orders: "مکمل آرڈرز",
  cancelled_orders: "منسوخ آرڈرز",
  branch_from: "بھیجنے والی برانچ",
  branch_to: "وصول کرنے والی برانچ",
  draft_invoices: "مسودہ انوائسز",
  open_invoices: "کھلی انوائسز",
  partially_paid_invoices: "جزوی طور پر ادا شدہ انوائسز",
  paid_invoices: "ادا شدہ انوائسز",
  balance: "بقایا",
  due_date: "ادائیگی کی آخری تاریخ",
  low_stock: "کم اسٹاک",
  net_sales: "خالص فروخت",
  total_sales: "کل فروخت",
  refunds: "رقم کی واپسی",
  sales: "فروخت",
  payments: "ادائیگیاں",
  net_total: "خالص مجموعہ",
  total_refunds: "کل واپسی",
  total: "کل",
  vat: "ویلیو ایڈڈ ٹیکس",
  taxes_on_sale: "فروخت پر ٹیکس",
  total_taxes_on_sale: "فروخت پر کل ٹیکس",
  quarterly_tax: "سہ ماہی فروخت پر ٹیکس",
  payment_types: "ادائیگی کی اقسام",
  quarterly_sales: "سہ ماہی فروخت",
  sales_overview: "فروخت کا جائزہ",
  warning_remove: "کیا آپ واقعی اس ادارے کو ہٹانا چاہتے ہیں؟",
  warning_delete: "کیا آپ واقعی اس ادارے کو حذف کرنا چاہتے ہیں؟",
  warning_logout: "کیا آپ واقعی لاگ آؤٹ کرنا چاہتے ہیں؟",
  warning_empty_basket: "کیا آپ واقعی یہ پروڈکٹس ٹوکری سے حذف کرنا چاہتے ہیں؟",
  warning_remove_product: "کیا آپ واقعی یہ پروڈکٹ ٹوکری سے حذف کرنا چاہتے ہیں؟",
  warning_delete_stock_product: "توجہ دیں: یہ پروڈکٹ حذف کرنے سے اس کا اسٹاک بھی خودکار طور پر حذف ہو جائے گا۔",
  warning_unsubscribe_addon: "اضافی سہولت کی سبسکرپشن ختم کرنے کے 3 دن بعد اس کا ڈیٹا سرور سے حذف ہو جائے گا۔",
  status_paid: "ادا شدہ",
  status_refunded: "واپس شدہ",
  yes: "ہاں",
  no: "نہیں",
  logout: "لاگ آؤٹ",
  logging_out: "لاگ آؤٹ ہو رہا ہے...",
  cancel: "منسوخ کریں",
  add: "شامل کریں",
  edit: "ترمیم کریں",
  update: "اپ ڈیٹ کریں",
  submit: "جمع کریں",
  confirm: "تصدیق کریں",
  search: "تلاش کریں",
  upload: "اپ لوڈ کریں",
  back: "واپس",
  order_id: "آرڈر آئی ڈی",
  order_details: "آرڈر کی تفصیلات",
  issued_at: "جاری کرنے کا وقت",
  date_range: "تاریخوں کی حد",
  delete_entity: "حذف کریں",
  something_went_wrong: "کچھ غلط ہو گیا",
  refund: "رقم واپس کریں",
  user_can_edit_price_on_pos: "صارف پی او ایس پر قیمت بدل سکتا ہے",
  user_can_apply_discount: "صارف رعایت دے سکتا ہے",
  user_see_transactions: "صارف لین دین دیکھ سکتا ہے",
  user_can_refund_transaction: "صارف لین دین کی رقم واپس کر سکتا ہے",
  user_can_add_edit_products: "صارف پروڈکٹس شامل اور ان میں ترمیم کر سکتا ہے",
  user_can_request_stock_transfer: "صارف اسٹاک منتقلی کی درخواست کر سکتا ہے",
  user_can_approve_stock_transfer: "صارف اسٹاک منتقلی منظور کر سکتا ہے",
  user_allowed_stock_adjustment: "صارف اسٹاک ایڈجسٹمنٹ کر سکتا ہے",
  user_can_add_edit_customers: "صارف گاہک شامل اور ان میں ترمیم کر سکتا ہے",
  user_can_view_customers: "صارف گاہک دیکھ سکتا ہے",
  user_can_add_pay_sales_invoices: "صارف اے فور سیلز انوائس بنا اور ادا کر سکتا ہے",
  user_can_view_sales_invoices: "صارف اے فور سیلز انوائس دیکھ سکتا ہے",
  user_can_scan_view_ticket: "صارف ٹکٹ اسکین اور دیکھ سکتا ہے",
  user_can_manage_zatca: "صارف زاتکا ای انوائسنگ کا انتظام کر سکتا ہے",
  is_machine_user: "مشین صارف ہے",
  proceed: "آگے بڑھیں",
  checkout: "چیک آؤٹ",
  payment_type: "ادائیگی کی قسم",
  cash_collected: "وصول شدہ نقد رقم",
  reference_no: "حوالہ نمبر",
  collected_by_cash: "نقد وصولی",
  collected_by_card: "کارڈ سے وصولی",
  charged_amount: "وصول کی گئی رقم",
  ask_more_cash: "آگے بڑھنے سے پہلے مزید نقد رقم لیں!",
  return_back_amount: "واپس کی جانے والی رقم",
  collect_more_cash: "مزید نقد رقم وصول کریں",
  print: "پرنٹ کریں",
  print_bill: "بل پرنٹ کریں",
  print_invoice: "انوائس پرنٹ کریں",
  declaration: "اقرار نامہ",
  declaration_text: "میں اقرار کرتا ہوں کہ اس فارم میں دی گئی معلومات درست اور مکمل ہیں۔ اگر کوئی معلومات غلط یا نامکمل پائی جائیں اور اس سے قواعد کی خلاف ورزی ہو تو قانونی کارروائی کی جا سکتی ہے۔ میں تمام متعلقہ چارجز، جرمانوں اور خلاف ورزیوں کی ذمہ داری قبول کرتا ہوں۔",
  stc_pay_declaration_text: "میں اقرار کرتا ہوں کہ اس فارم میں دیا گیا ایس ٹی سی پے حوالہ نمبر درست اور مکمل ہے۔ آپ کا بیلنس ایک کام کے دن کے اندر ڈیش بورڈ پر ظاہر ہو جائے گا۔",
  upgrade: "اپ گریڈ کریں",
  upgrade_subscription: "سبسکرپشن اپ گریڈ کریں",
  payment_successful: "ادائیگی کامیاب ہوئی",
  your_payment_successfully: "آپ کی ادائیگی کامیاب رہی۔",
  payment_failed: "ادائیگی ناکام ہوئی",
  try_again_payment_failed: "آپ کی ادائیگی ناکام ہو گئی۔ دوبارہ کوشش کریں۔",
  all: "سب",
  cart_empty: "آپ کا کارٹ خالی ہے۔",
  total_amount: "کل رقم",
  licenses: "لائسنس",
  purchase: "خریدیں",
  credit_card: "کریڈٹ کارڈ",
  stc_pay: "ایس ٹی سی پے",
  mada: "مدا",
  cash: "نقد",
  card: "کارڈ",
  bank: "بینک",
  multi_payment: "متعدد طریقوں سے ادائیگی",
  plz_fill_details: "آگے بڑھنے کے لیے نیچے تفصیلات درج کریں",
  billing_details: "بل کی تفصیلات",
  business_address_details: "کاروباری پتے کی تفصیلات",
  discount: "رعایت",
  select_a_discount: "رعایت منتخب کریں",
  unpaid_invoice: "غیر ادا شدہ انوائس!",
  pay_your_invoice: "اپنی غیر ادا شدہ انوائس ادا کریں",
  show_invoices: "انوائسز دکھائیں",
  what_type_of_refund: "آپ کس قسم کی رقم واپسی چاہتے ہیں؟",
  full: "مکمل",
  partial: "جزوی",
  refund_amount: "واپس کی جانے والی رقم",
  zatca_refund_reason_required: "زاتکا کے لیے رقم واپسی کی وجہ ضروری ہے",
  zatca_refund_reason_helper: "اس لین دین کی زاتکا انوائس بنائی گئی تھی۔ وہ وجہ منتخب کریں جو رقم واپسی کے کریڈٹ نوٹ کے ساتھ بھیجی جائے گی۔",
  select_zatca_refund_reason: "رقم واپسی کی وجہ منتخب کریں",
  zatca_refund_reason_cancellation_suspension: "منسوخی یا معطلی",
  zatca_refund_reason_goods_services_refund: "سامان یا خدمات کی واپسی",
  zatca_refund_reason_price_reduction_discount: "قیمت میں کمی یا رعایت",
  zatca_refund_reason_invoice_errors: "انوائس میں غلطیاں",
  zatca_refund_reason_change_in_information: "معلومات میں تبدیلی",
  qty: "مقدار",
  additional_info: "اضافی معلومات",
  users: "صارفین",
  action: "عمل",
  pay_now: "ابھی ادائیگی کریں",
  view_invoice: "انوائس دیکھیں",
  one_time_payment: "ایک بار کی ادائیگی",
  complete: "مکمل",
  incomplete: "نامکمل",
  max_upload_size_10mb_warning: "اپ لوڈ کا زیادہ سے زیادہ حجم: 10MB",
  max_upload_size_2mb_warning: "اپ لوڈ کا زیادہ سے زیادہ حجم: 2MB",
  account_under_verification: "آپ کے اکاؤنٹ کی تصدیق جاری ہے!",
  notified_once_verified: "رجسٹریشن کا شکریہ۔ اکاؤنٹ کی تصدیق کے بعد آپ کو موبائل نمبر پر اطلاع دی جائے گی۔",
  account_blocked: "آپ کا اکاؤنٹ بلاک کر دیا گیا ہے!",
  kindly_contact_at: "براہ کرم contact@anypos.ai پر رابطہ کریں",
  is_vat_exempt: "میرے پاس ویلیو ایڈڈ ٹیکس سرٹیفکیٹ نہیں ہے",
  vat_exempt_latter_sample: "ٹیکس استثنا کے خط کا نمونہ",
  vat_exempt_latter: "ٹیکس استثنا کا خط",
  connection: "کنکشن",
  connected: "منسلک",
  disconnected: "منقطع",
  download_report: "رپورٹ ڈاؤن لوڈ کریں",
  download_sales_report: "فروخت کی رپورٹ ڈاؤن لوڈ کریں",
  download_payments_report: "ادائیگیوں کی رپورٹ ڈاؤن لوڈ کریں",
  download_template: "نمونہ ڈاؤن لوڈ کریں",
  skip: "چھوڑ دیں",
  fill_the_details: "تفصیلات درج کریں",
  kindly_complete_the_store_details_within: "براہ کرم دکان کی تفصیلات اس مدت کے اندر مکمل کریں",
  days_otherwise_your_account_will_be_blocked: "دنوں میں، ورنہ آپ کا اکاؤنٹ بلاک ہو جائے گا۔",
  unlimited: "لامحدود",
  per_user: "فی صارف",
  payment_modal: "ادائیگی کی ونڈو",
  select_payment_method: "ادائیگی کا طریقہ منتخب کریں",
  service_name: "سروس کا نام",
  subscriptions_history: "سبسکرپشن کی تاریخ",
  spending_history: "اخراجات کی تاریخ",
  trial_days: "آزمائشی دن",
  paid: "ادا شدہ",
  unpaid: "غیر ادا شدہ",
  qr: "کیو آر",
  dining_table: "کھانے کی میز",
  note: "نوٹ",
  clear: "صاف کریں",
  selected_item: "منتخب شے",
  pending: "زیرِ انتظار",
  completed: "مکمل",
  cancelled: "منسوخ",
  refunded: "واپس کی گئی",
  recharge_request: "ریچارج کی درخواست",
  rejected: "مسترد",
  available_stock: "دستیاب اسٹاک",
  requested_stock: "درخواست کردہ اسٹاک",
  current_stock: "موجودہ اسٹاک",
  your_branch: "آپ کی برانچ",
  approved_quantity: "منظور شدہ مقدار",
  requested_quantity: "درخواست کردہ مقدار",
  insufficient_quantity: "مقدار ناکافی ہے",
  out_of_stock: "اسٹاک ختم",
  product_already_selected: "پروڈکٹ پہلے ہی منتخب ہے",
  basket: "ٹوکری",
  search_product_name_here: "مصنوعے کا نام یہاں تلاش کریں",
  welcome_to: "خوش آمدید",
  call_to_waiter: "ویٹر کو بلائیں",
  order: "آرڈر",
  select_language: "زبان منتخب کریں",
  place_order: "آرڈر دیں",
  basket_empty: "آپ کی ٹوکری خالی ہے۔",
  menu: "مینو",
  order_placed_successfully: "آپ کا آرڈر کامیابی سے دے دیا گیا!",
  hi: "سلام",
  welcome_anypos: "AnyPOS میں خوش آمدید!",
  place_new_order: "نیا آرڈر دیں",
  your_order: "آپ کا آرڈر",
  expired: "میعاد ختم ہو گئی",
  is_expired: "میعاد ختم ہو چکی ہے",
  late_payment: "تاخیر سے ادائیگی",
  is_late_payment: "ادائیگی میں تاخیر ہوئی ہے",
  addon_selected: "اضافی سہولت منتخب ہے",
  all_prices_daily_basis: "تمام قیمتیں یومیہ بنیاد پر ہیں۔",
  we_only_charge_use_addon: "اضافی سہولت کے استعمال پر ہی چارج کیا جائے گا۔",
  free: "مفت",
  free_trial: "آزمائشی مدت میں مفت",
  need_addons: "اضافی سہولتیں چاہییں؟",
  value: "قدر",
  taxes: "ٹیکس",
  total_without_tax: "ٹیکس کے بغیر کل",
  price_including_tax: "ٹیکس سمیت قیمت",
  total_taxes: "کل ٹیکس",
  total_with_tax: "ٹیکس سمیت کل",
  branch_selling_products: "برانچ میں فروخت ہونے والی پروڈکٹس",
  filters: "فلٹرز",
  sales_insight: "فروخت کا تجزیہ",
  disabled: "غیر فعال",
  after_trials: "آزمائشی مدت کے بعد فی دن",
  cannot_select_table_management_while_job_management_is_active: "کاموں کا انتظام فعال ہونے کے دوران میزوں کا انتظام منتخب نہیں کیا جا سکتا۔",
  cannot_select_job_management_while_waiter_management_or_table_management_is_active: "ویٹر یا میزوں کا انتظام فعال ہونے کے دوران کاموں کا انتظام منتخب نہیں کیا جا سکتا۔",
  cannot_select_waiter_management_while_job_management_is_active: "کاموں کا انتظام فعال ہونے کے دوران ویٹر کا انتظام منتخب نہیں کیا جا سکتا۔",
  dependent_addons: "منسلک اضافی سہولتیں",
  successfully_added: "کامیابی سے شامل ہو گیا",
  generate_ai_image_for_one_product: "ایک پروڈکٹ کے لیے اے آئی تصویر بنائیں",
  generate_ai_images_for_products: "{{count}} پروڈکٹس کے لیے اے آئی تصاویر بنائیں",
  generating_images_with_ai: "{{count}} پروڈکٹس کے لیے اے آئی تصاویر بن رہی ہیں",
  image_generated: "تصویر بن گئی",
  image_generated_successfully: "تصویر کامیابی سے بن گئی!",
  images_generated: "تصاویر بن گئیں",
  images_generated_successfully: "{{count}} پروڈکٹس کی تصاویر کامیابی سے بن گئیں!",
  images_generation_started: "اے آئی تصاویر بننے کا عمل شروع ہو گیا",
  images_generation_started_desc: "{{count}} پروڈکٹس کی تصاویر پس منظر میں بن رہی ہیں۔",
  images_generation_failed: "تصاویر نہیں بن سکیں",
  images_generation_completed_with_errors: "{{completed}} تصاویر بن گئیں، {{failed}} ناکام رہیں۔",
  products_already_have_images: "منتخب پروڈکٹس کی تصاویر پہلے سے موجود ہیں۔",
  image_generation_live_updates_unavailable: "براہ راست اپ ڈیٹس دستیاب نہیں؛ نئی تصاویر پروڈکٹس کی فہرست دوبارہ کھولنے پر نظر آئیں گی۔",
  Showing_transactions_from_all_branches: "تمام برانچوں کے لین دین دکھائے جا رہے ہیں",
  Showing_transactions_from_my_branch: "میری برانچ کے لین دین دکھائے جا رہے ہیں",
  all_data: "تمام ڈیٹا",
  branch_data: "برانچ کا ڈیٹا",
  Showing_orders_from_all_branches: "تمام برانچوں کے آرڈرز دکھائے جا رہے ہیں",
  Showing_orders_from_my_branch: "میری برانچ کے آرڈرز دکھائے جا رہے ہیں",
  total_stock: "کل اسٹاک",
  branch_stock: "برانچ کا اسٹاک",
  view_all: "سب دیکھیں",
  photo: "تصویر",
  nationality: "قومیت",
  id_number: "شناختی نمبر",
  products_by_category: "زمرے کے لحاظ سے پروڈکٹس",
  view_details: "تفصیلات دیکھیں",
  how_would_you_like_to_order: "آپ آرڈر کیسے دینا چاہیں گے؟",
  order_with_ai: "اے آئی کی مدد سے آرڈر دیں",
  order_yourself: "خود آرڈر دیں",
  no_menu_data_found: "مینو کا ڈیٹا نہیں ملا",
  please_scan_valid_qr_code_or_try_again_later: "درست کیو آر کوڈ اسکین کریں یا بعد میں دوبارہ کوشش کریں۔",
  order_mode: "آرڈر کا طریقہ",
  change_mode: "طریقہ تبدیل کریں",
  powered_by_anypos: "AnyPOS کی معاونت سے",
  is_calories: "کیلوریز دکھائیں",
  calories_info: "کیلوریز کی معلومات",
  calories: "کیلوریز",
  configuration: "ترتیبات",
  trial_addons_expiring_today: "آپ کی اضافی سہولتوں کی آزمائشی مدت آج ختم ہو رہی ہے",
  trial_addons_message: "یہ اضافی سہولتیں آزمائشی مدت میں ہیں جو آج ختم ہو جائے گی۔ انہیں برقرار رکھنے پر کل سے چارجز شروع ہوں گے اور آپ کے بیلنس سے کٹیں گے۔ کیا آپ انہیں رکھنا چاہتے ہیں یا سبسکرپشن ختم کرنا چاہتے ہیں؟",
  trial_ends_today: "آزمائشی مدت آج ختم ہو رہی ہے",
  unsubscribe_all_addons: "سب کی سبسکرپشن ختم کریں",
  keep_addons: "اضافی سہولتیں برقرار رکھیں",
  needs: "درکار ہیں",
  affects: "اثر انداز ہوتا ہے",
  addon_needs_title: "اس اضافی سہولت کو دوسری سہولتیں درکار ہیں",
  addon_needs_description: "{{addon}} کو فعال رکھنے کے لیے درج ذیل اضافی سہولتیں بھی فعال رہنی چاہییں:",
  addon_affects_title: "اس اضافی سہولت کو ہٹانے سے دوسری خصوصیات متاثر ہوں گی",
  addon_affects_description: "اگر آپ {{addon}} کو غیر فعال کرتے ہیں تو اس پر منحصر درج ذیل سہولتیں بھی غیر فعال ہو جائیں گی:",
  addons_updated: "اضافی سہولتیں اپ ڈیٹ ہو گئیں",
  addons_updated_successfully: "آپ کی اضافی سہولتوں کی ترجیحات کامیابی سے اپ ڈیٹ ہو گئیں!",
  also_disabled_depends_on: "بھی غیر فعال ہو جائے گی کیونکہ یہ اس پر منحصر ہے",
  addon_depends_on_message: "{{addon}} کا انحصار {{addons}} پر ہے۔ پہلے {{target}} منتخب کریں۔",
  addon_remove_affects_message: "{{addons}} کا انحصار {{addon}} پر {{verb}} ہے۔ {{pronoun}} بھی ہٹا دی جائیں گی۔",
  depend: "ہوتا",
  depends: "ہوتا",
  it: "یہ",
  these: "یہ",
  that: "وہ",
  those: "وہ",
  generating_image_with_ai: "انتظار کریں۔ ہم آپ کے لیے بہترین تصویر بنا رہے ہیں۔",
  please_wait_a_moment: "تھوڑی دیر انتظار کریں",
  addon_needs_short: "{{addon}} کو کام کرنے کے لیے یہ اضافی سہولتیں درکار ہیں۔",
  addon_affects_short: "اگر آپ {{addon}} غیر فعال کرتے ہیں تو یہ اضافی سہولتیں بھی غیر فعال ہو سکتی ہیں۔",
  customer_display: "گاہک کی اسکرین",
  product_expired: "پروڈکٹ کی میعاد ختم ہو گئی",
  dine_in: "یہیں کھائیں",
  takeaway: "ساتھ لے جائیں",
  kitchen_status: "باورچی خانے کی حالت",
  awaiting: "انتظار میں",
  preparing: "تیار ہو رہا ہے",
  cooked: "تیار ہے",
  order_type: "آرڈر کی قسم",
  display_screens: "ڈسپلے اسکرینیں",
  last_seen: "آخری بار دیکھا گیا",
  bound_by: "منسلک کرنے والا",
  unbind_this_device: "اس آلے کا رابطہ ختم کریں؟",
  unbind_pos_and_cds: "پی او ایس اور منسلک گاہک کی اسکرین کا رابطہ ختم کریں؟",
  device_added: "آلہ شامل کر دیا گیا",
  device_added_successfully: "آلہ کامیابی سے شامل ہو گیا!",
  device_unbind: "آلے کا رابطہ ختم کریں",
  device_unbind_successfully: "آلے کا رابطہ کامیابی سے ختم ہو گیا!",
  add_kitchen_screen: "باورچی خانے کی اسکرین شامل کریں",
  add_customer_screen: "گاہک کی اسکرین شامل کریں",
  generate_code: "کوڈ بنائیں",
  customer_display_screen: "گاہک کی ڈسپلے اسکرین",
  register_pos_terminal: "پی او ایس ٹرمینل رجسٹر کریں",
  pos_terminal: "پی او ایس ٹرمینل",
  expires_in: "میعاد ختم ہونے میں",
  register_pos_terminal_first: "پہلے پی او ایس ٹرمینل رجسٹر کریں",
  enter_pairing_code_instruction: "یہ جوڑنے والا کوڈ ڈسپلے اسکرین پر درج کریں۔ اس کی میعاد ختم ہونے میں ",
  pairing_code_expired_message: "جوڑنے والے کوڈ کی میعاد ختم ہو گئی ہے۔ نیا کوڈ بنائیں۔",
  linked_pos_uid: "منسلک پی او ایس شناختی نمبر",
  not_registered: "رجسٹر نہیں ہے",
  kitchen_display_screens: "باورچی خانے کی ڈسپلے اسکرینیں",
  kitchen_display_screen: "باورچی خانے کی ڈسپلے اسکرین",
  pos_terminal_already_registered: "پی او ایس ٹرمینل پہلے ہی رجسٹر ہے۔ پہلے اس کا رابطہ ختم کریں۔",
  open_screen_device_url_instruction: "اسکرین والے آلے پر یہ یو آر ایل کھولیں، پھر تصدیقی کوڈ درج کریں:",
  takeaway_cancel_refund_warning: "یہ ساتھ لے جانے والا آرڈر منسوخ کرنے پر اس کی رقم خودکار طور پر واپس ہو جائے گی۔",
  transaction_refunded: "لین دین کی رقم واپس ہو گئی",
  transaction_refunded_successfully: "لین دین کی رقم کامیابی سے واپس ہو گئی!",
  cancel_order_before_refund: "اس آرڈر کی رقم واپس کرنے کے لیے پہلے آرڈر منسوخ کریں۔",
  ok: "ٹھیک ہے",
  pricing_badge: "منتخب ماڈیولز پر {{days}} دن کی مفت آزمائش · کریڈٹ کارڈ درکار نہیں",
  simple_pricing: "سادہ قیمتیں۔",
  pay_only_for_what_you_use: "صرف استعمال کے مطابق ادائیگی کریں۔",
  pricing_hero_desc: "مفت آغاز کریں۔ تیار ہونے پر بیلنس بڑھائیں۔ صرف کاروبار کھلے ہونے والے دنوں کی ادائیگی کریں؛ مستقل سبسکرپشن فیس نہیں۔",
  pricing_free_trial_included: "{{days}} دن کی مفت آزمائش شامل ہے",
  pricing_trial_desc: "{{addons}}، {{days}} دن کے لیے مفت ہیں۔ کوئی پابندی نہیں۔",
  how_many_users: "کتنے صارفین؟",
  pos_users: "پی او ایس صارفین",
  pricing_users_desc: "ہر صارف = فعال دن کے لیے {{amount}} سعودی ریال · صرف لاگ اِن کرنے پر چارج",
  per_day: "فی دن",
  included_in_every_plan: "ہر پلان میں شامل",
  point_of_sale: "پوائنٹ آف سیل",
  zatca_invoicing: "زاتکا ای انوائسنگ",
  customer_database: "گاہکوں کا ڈیٹا بیس",
  multi_branch: "متعدد برانچیں",
  products_catalogue: "پروڈکٹس کی فہرست",
  sales_reports: "فروخت کی رپورٹیں",
  tap_to_pay: "ٹیپ کر کے ادائیگی",
  business_types: "کاروبار کی اقسام",
  choose_your_modules: "اپنے ماڈیولز منتخب کریں",
  included_in_this_group: "اس گروپ میں شامل",
  pricing_no_extra_dependency: "کسی اضافی سہولت کی ضرورت نہیں",
  your_plan_summary: "آپ کے پلان کا خلاصہ",
  daily_total: "یومیہ کل",
  daily_subscription_plan_unavailable: "یومیہ سبسکرپشن پلان فی الحال دستیاب نہیں۔ بعد میں دوبارہ کوشش کریں۔",
  pricing_after_trial_note: "{{days}} دن کی آزمائش کے بعد · صرف فعال دنوں پر",
  included: "شامل",
  start_free_trial: "مفت آزمائش شروع کریں",
  pricing_cta_line_1: "بامعاوضہ ماڈیولز پر {{days}} دن کی آزمائش · کریڈٹ کارڈ درکار نہیں",
  pricing_cta_line_2: "آزمائش کے بعد یومیہ {{amount}} سعودی ریال جمع ٹیکس ادا کریں",
  complete_signup_details: "مفت آزمائش فعال کرنے کے لیے کاروباری تفصیلات مکمل کریں۔",
  otp_verify_subtitle: "آگے بڑھنے کے لیے موبائل نمبر پر بھیجا گیا کوڈ درج کریں۔",
  pricing_group_fnb_title: "کیفے، ریستوران اور خوراک کا کاروبار",
  pricing_group_fnb_desc: "خوراک کے کاروبار کے لیے آرڈر، میز، باورچی خانے اور ویٹر کا انتظام",
  pricing_group_job_title: "مرمت، کار واش اور ڈیلیوری",
  pricing_group_job_desc: "فیلڈ سروس ٹیموں کے کاموں اور ذمہ داریوں کا ریکارڈ",
  pricing_group_stock_title: "اسٹاک کا انتظام",
  pricing_group_stock_desc: "اسٹاک کی فوری نگرانی، کم اسٹاک کی اطلاع اور پروڈکٹس کی فہرست",
  pricing_group_ticket_title: "ٹکٹوں کا نظام",
  pricing_group_ticket_desc: "تقریبات، پارکنگ، شوز اور تفریحی مقامات کے ٹکٹ فروخت اور اسکین کریں",
  popup_pos_eyebrow: "پی او ایس صارفین — شامل خصوصیات",
  popup_pos_title: "ہر فروخت کرنے والے کاروبار کے لیے",
  popup_pos_desc: "بنیادی پی او ایس پلان میں روزمرہ فروخت، زاتکا کے مطابق انوائسز اور گاہکوں کے انتظام کے لیے درکار تمام سہولتیں شامل ہیں؛ مزید ماڈیول درکار نہیں۔",
  popup_fnb_title: "خوراک اور مشروبات کے کاروبار کے لیے تیار",
  popup_fnb_desc: "اس ماڈیول میں میزوں کا انتظام، ویٹر کی تعیناتی، کیو آر آرڈر، باورچی خانے اور گاہک کی اسکرین شامل ہیں۔",
  popup_job_title: "فیلڈ سروس اور کاموں پر مبنی کاروبار کے لیے",
  popup_job_desc: "اس ماڈیول سے تکنیکی کارکنوں کو کام سونپیں، پیش رفت براہ راست دیکھیں اور بکنگ سے تکمیل تک گاہک کی خدمات سنبھالیں۔",
  popup_stock_title: "سامان کا اسٹاک رکھنے والے ہر کاروبار کے لیے",
  popup_stock_desc: "اسٹاک کی نگرانی کریں، کمی پر اطلاع پائیں اور کئی برانچوں کی پروڈکٹس سنبھالیں؛ ہر قسم کے کاروبار کے لیے موزوں۔",
  industry_gold_jewelry: "سونے اور زیورات کی دکانیں",
  industry_clothing_fashion: "کپڑے اور فیشن",
  industry_pharmacies: "دواخانے",
  industry_grocery_supermarkets: "کریانہ اور سپر مارکیٹس",
  industry_cosmetics_beauty: "کاسمیٹکس اور بیوٹی",
  industry_electronics_phones: "الیکٹرانکس اور فون",
  industry_furniture_home: "فرنیچر اور گھریلو سامان",
  industry_laundry_dry_clean: "لانڈری اور ڈرائی کلین",
  industry_salons_barbershops: "سیلون اور حجام کی دکانیں",
  industry_any_retail_business: "ہر قسم کا خوردہ کاروبار",
  industry_cafes_coffee_shops: "کیفے اور کافی شاپس",
  industry_dine_in_restaurants: "ریستوران",
  industry_fast_food_qsr: "فاسٹ فوڈ اور فوری سروس والے ریستوران",
  industry_food_courts: "فوڈ کورٹس",
  industry_bakeries_desserts: "بیکریاں اور میٹھے",
  industry_healthy_food_outlets: "صحت بخش کھانوں کی دکانیں",
  industry_drive_through: "ڈرائیو تھرو",
  industry_cloud_kitchens: "کلاؤڈ کچنز",
  industry_ac_hvac_repair: "اے سی اور ہوا کی فراہمی کے نظام کی مرمت",
  industry_car_wash_detailing: "کار واش اور گاڑی کی صفائی",
  industry_electrical_services: "بجلی کی خدمات",
  industry_plumbing_maintenance: "پلمبنگ اور دیکھ بھال",
  industry_cleaning_services: "صفائی کی خدمات",
  industry_delivery_logistics: "ڈیلیوری اور ترسیل",
  industry_moving_services: "منتقلی کی خدمات",
  industry_home_healthcare: "گھر پر صحت کی دیکھ بھال",
  industry_gold_jewelry_short: "سونا اور زیورات",
  industry_fashion_clothing: "فیشن اور کپڑے",
  industry_grocery_stores: "کریانہ کی دکانیں",
  industry_restaurants: "ریستوران",
  industry_wholesale_distribution: "تھوک فروشی اور تقسیم",
  industry_hardware_tools: "ہارڈویئر اور اوزار",
  industry_beauty_cosmetics: "بیوٹی اور کاسمیٹکس",
  validation_error: "تصدیق کی خرابی",
  otp_validation_failed_try_again: "تصدیقی کوڈ کی جانچ ناکام رہی۔ دوبارہ کوشش کریں۔",
  zatca_settings: "زاتکا ترتیبات — فروخت کنندہ کا پتہ",
  zatca_settings_subtitle: "ہر الیکٹرانک انوائس پر زاتکا کی ضرورت۔ آلے کی رجسٹریشن میں استعمال ہوتا ہے۔",
  zatca_settings_helper_title: "الیکٹرانک انوائسنگ کے لیے ضروری",
  zatca_settings_helper: "برانچ کے لیے زاتکا فعال کرنے سے پہلے تمام خانے پُر کرنا ضروری ہے۔",
  business_name_arabic: "کاروبار کا نام اردو میں",
  street_name: "گلی کا نام",
  plot_identification: "پلاٹ کا شناختی نمبر",
  district: "ضلع",
  address_sa_help: "یہ تفصیلات معلوم نہیں؟ address.sa پر تلاش کریں ←",
  company_data_validation_failed: "کمپنی کے ڈیٹا کی جانچ ناکام رہی۔ آگے بڑھنے سے پہلے زاتکا کے لیے فروخت کنندہ کے پتے کے تمام خانے مکمل کریں۔",
  business_information: "کاروباری معلومات",
  business_information_helper: "آپ کے کاروبار کی بنیادی تفصیلات، جو رسیدوں اور رپورٹوں میں نظر آتی ہیں۔",
  tax_compliance: "ٹیکس اور قواعد کی پابندی",
  tax_compliance_helper: "ٹیکس کے قواعد کی پابندی کے لیے ضروری رجسٹریشن نمبر اور سرٹیفکیٹ۔",
  business_address_details_helper: "انوائسز اور کاروباری دستاویزات میں استعمال ہونے والا سرکاری کاروباری پتہ۔",
  kindly_check_declaration: "آگے بڑھنے سے پہلے اقرار نامے کی تصدیق کریں۔",
  remove: "ہٹائیں",
  remove_logo: "لوگو ہٹائیں",
  confirm_remove_logo: "کیا آپ واقعی کاروبار کا لوگو ہٹانا چاہتے ہیں؟ محفوظ شدہ لوگو حذف ہو جائے گا۔",
  logo_removed: "لوگو ہٹا دیا گیا۔",
  zatca_enable_question: "کیا آپ زاتکا فیز 2 الیکٹرانک انوائسنگ منسلک کرنا چاہتے ہیں؟",
  zatca_enable_helper: "سعودی عرب میں ٹیکس انوائسز جاری کرنے والے کاروباروں کے لیے ضروری۔",
  zatca_locked_helper: "زاتکا کے لیے فروخت کنندہ کے پتے کی تفصیلات جمع ہو چکی ہیں اور اب تبدیل نہیں کی جا سکتیں۔ تبدیلی کے لیے سپورٹ سے رابطہ کریں۔",
  zatca_not_configured: "اس دکان کے لیے زاتکا الیکٹرانک انوائسنگ فعال نہیں ہے۔",
  zatca_not_configured_helper: "تیار ہونے پر ترمیم کا فارم کھولیں، زاتکا فیز 2 فعال کریں اور فروخت کنندہ کے پتے کی تفصیلات درج کریں۔",
  zatca_onboarding: "زاتکا رجسٹریشن",
  zatca_invoices: "زاتکا انوائسز",
  zatca_invoice_issues: "زاتکا انوائسز کے مسائل",
  zatca_invoice_issues_failed: "زاتکا انوائسز کے مسائل لوڈ نہیں ہو سکے",
  issue_type: "مسئلے کی قسم",
  issue_summary: "مسئلے کا خلاصہ",
  search_invoice_issues_placeholder: "انوائس UUID، تجارتی رجسٹریشن نمبر، تنبیہ یا خرابی کے متن سے تلاش کریں",
  onboard_zatca: "زاتکا پر رجسٹر کریں",
  enable_zatca: "زاتکا فعال کریں",
  device_name: "آلے کا نام",
  environment: "ماحول",
  csid_expiry: "CSID کی میعاد",
  last_icv: "آخری ICV",
  missing_fields: "نامکمل خانے",
  zatca_kyc_complete_title: "تصدیقی پتے کے خانے مکمل ہیں",
  zatca_kyc_incomplete_title: "پہلے زاتکا کا پتہ مکمل کریں",
  zatca_kyc_incomplete_helper: "دکان کے پروفائل میں زاتکا کے لیے ضروری فروخت کنندہ کے پتے کے کچھ خانے خالی ہیں۔ انہیں پُر کرنے کے لیے دکان کی ترتیبات کھولیں۔",
  complete_zatca_address_fields: "زاتکا کے پتے کے خانے مکمل کریں",
  env_sandbox: "سینڈ باکس",
  env_simulation: "نقلی ماحول",
  env_production: "اصل ماحول",
  get_your_otp: "اپنا تصدیقی کوڈ حاصل کریں",
  zatca_otp_instructions_helper: "fatoora.zatca.gov.sa کھولیں ← ای انوائس رجسٹریشن ← تصدیقی کوڈ بنائیں۔ ایک گھنٹے تک مؤثر۔",
  copy_portal_url: "پورٹل کا یو آر ایل کاپی کریں",
  zatca_portal_url_copied: "پورٹل کا یو آر ایل کلپ بورڈ پر کاپی ہو گیا۔",
  otp_6_digits: "تصدیقی کوڈ (6 ہندسے)",
  already_onboarded: "اس ماحول کے لیے پہلے ہی رجسٹر ہے",
  csid_expired: "CSID کی میعاد ختم ہو گئی",
  failed: "ناکام",
  device_onboarded: "آلہ رجسٹر ہو گیا",
  zatca_onboard_success_helper: "{{environment}} ماحول میں {{branch}} کے لیے زاتکا فعال ہو گیا ہے۔",
  zatca_onboard_failed_helper: "یہ آلہ رجسٹر نہیں ہو سکا۔ تصدیقی کوڈ جانچ کر دوبارہ کوشش کریں۔",
  permission_required_title: "اجازت ضروری ہے",
  zatca_permission_required_helper: "صرف زاتکا کی اجازت رکھنے والے صارفین آلات رجسٹر کر سکتے ہیں۔ کاروبار کے مالک سے کہیں کہ ملازمین کی اجازتوں میں یہ اختیار دے۔",
  zatca_taking_longer_title: "زاتکا معمول سے زیادہ وقت لے رہا ہے",
  zatca_taking_longer_helper: "قواعد کی جانچ جاری ہے۔ خودکار طور پر دوبارہ کوشش ہو گی؛ یہ ونڈو بند نہ کریں۔",
  onboarded_at: "رجسٹریشن کا وقت",
  device_uuid: "آلے کا UUID",
  expiring_in_days_one: "{{count}} دن میں میعاد ختم ہو گی",
  expiring_in_days_other: "{{count}} دنوں میں میعاد ختم ہو گی",
  zatca_device_details: "زاتکا آلے کی تفصیلات",
  zatca_device_detail_failed: "زاتکا آلے کی تفصیلات لوڈ نہیں ہو سکیں۔",
  registered_by: "رجسٹر کرنے والا",
  invoices_count: "انوائسز کی تعداد",
  csid_valid: "CSID درست ہے",
  production_request_id: "اصل ماحول کی درخواست کا آئی ڈی",
  compliance_request_id: "قواعد کی جانچ کی درخواست کا آئی ڈی",
  last_pih: "آخری PIH",
  renew_now: "ابھی تجدید کریں",
  renew_csid: "CSID کی تجدید کریں",
  zatca_csid_renewed_title: "CSID کی تجدید ہو گئی",
  zatca_csid_renewed_helper: "زاتکا CSID کی کامیابی سے تجدید ہو گئی۔",
  zatca_csid_renew_failed: "CSID کی تجدید نہیں ہو سکی۔",
  zatca_get_otp_helper: "فاتورہ پورٹل کھولیں، نیا تصدیقی کوڈ بنائیں اور یہاں درج کریں۔",
  copy: "کاپی کریں",
  copied: "کاپی ہو گیا",
  devices_cannot_submit_banner_one: "تجدید تک {{count}} آلہ انوائسز جمع نہیں کر سکتا۔",
  devices_cannot_submit_banner_other: "تجدید تک {{count}} آلات انوائسز جمع نہیں کر سکتے۔",
  csid_expired_alert_helper: "اس CSID کی میعاد ختم ہو گئی ہے۔ زاتکا کو انوائسز جمع کرانے کے لیے ابھی تجدید کریں۔",
  pending_onboarding: "رجسٹریشن جاری ہے",
  compliance_pending: "قواعد کی جانچ جاری ہے",
  compliance_passed: "قواعد کی جانچ کامیاب رہی",
  onboarding_in_progress: "رجسٹریشن جاری ہے",
  customer_type: "گاہک کی قسم",
  buyer_name: "خریدار کا نام",
  buyer_vat: "خریدار کا ٹیکس نمبر",
  buyer_company_address: "خریدار کمپنی کا پتہ",
  arabic_only_validation: "صرف اردو حروف استعمال کریں",
  buyer_information: "خریدار کی معلومات",
  buyer_company_information: "خریدار یا کمپنی کی معلومات",
  zatca: "زاتکا",
  invoices_last_7_days: "گزشتہ 7 دنوں کی انوائسز",
  zatca_invoices_empty_default_filter: "منتخب مدت میں کوئی مسترد یا ناکام انوائس نہیں؛ یہ اچھی بات ہے۔",
  uuid: "UUID",
  subtype: "ذیلی قسم",
  when: "کب",
  zatca_invoice_retry_attempt: "{{minutes}} منٹ میں دوبارہ کوشش (کوشش {{n}}/{{max}})",
  download_xml: "دستخط شدہ XML ڈاؤن لوڈ کریں",
  retry: "دوبارہ کوشش کریں",
  zatca_invoice_retry_disabled_helper: "دوبارہ کوششوں کی قطار ابھی اس انوائس پر کام کر رہی ہے۔ {{max}} خودکار کوششوں کے بعد دستی کوشش دستیاب ہو گی۔",
  zatca_invoice_retry_success: "انوائس دوبارہ کوشش کی قطار میں شامل ہو گئی۔",
  zatca_invoice_retry_failed: "یہ انوائس دوبارہ کوشش کی قطار میں شامل نہیں ہو سکی۔",
  zatca_invoice_xml_failed: "دستخط شدہ XML ڈاؤن لوڈ نہیں ہو سکی۔",
  accepted: "قبول شدہ",
  accepted_with_warnings: "تنبیہات کے ساتھ قبول شدہ",
  submitted: "جمع شدہ",
  cleared: "منظور شدہ",
  reported: "رپورٹ شدہ",
  invoice: "انوائس",
  credit_note: "کریڈٹ نوٹ",
  debit_note: "ڈیبٹ نوٹ",
  zatca_subtype_standard: "کاروبار سے کاروبار (معیاری)",
  zatca_subtype_simplified: "کاروبار سے صارف (سادہ)",
  invoice_detail: "انوائس کی تفصیلات",
  zatca_errors: "زاتکا کی خرابیاں",
  warnings: "تنبیہات",
  no_errors: "زاتکا نے کوئی خرابی رپورٹ نہیں کی۔",
  no_warnings: "کوئی تنبیہ نہیں۔",
  icv: "ICV",
  pih: "PIH",
  transaction: "لین دین",
  submitted_at: "جمع کرانے کا وقت",
  zatca_invoice_qr_local: "مقامی کیو آر (فیز 2 TLV)",
  zatca_invoice_qr_zatca: "زاتکا کی مہر والا کیو آر (منظور شدہ XML سے)",
  zatca_csid_banner_expired_one: "{{branch}} کے سرٹیفکیٹ کی میعاد {{days}} دن پہلے ختم ہو گئی۔ تجدید تک اس برانچ کی انوائسز زاتکا کو رپورٹ نہیں کی جا سکتیں۔",
  zatca_csid_banner_expired_other: "{{branch}} کے سرٹیفکیٹ کی میعاد {{days}} دن پہلے ختم ہو گئی۔ تجدید تک اس برانچ کی انوائسز زاتکا کو رپورٹ نہیں کی جا سکتیں۔",
  zatca_csid_banner_expiring_red: "{{branch}} کے سرٹیفکیٹ کی میعاد {{days}} دن میں ختم ہو گی؛ سروس بند ہونے سے بچنے کے لیے ابھی تجدید کریں۔",
  zatca_csid_banner_expiring_amber: "{{branch}} کے سرٹیفکیٹ کی میعاد {{days}} دن میں ختم ہو گی۔ جلد تجدید کا انتظام کریں۔",
  zatca_csid_banner_blocking_title: "یہ برانچ فی الحال زاتکا انوائسز جاری نہیں کر سکتی",
  zatca_csid_banner_blocking_helper: "CSID کی میعاد ختم ہو گئی ہے۔ اس برانچ میں فروخت مکمل کرنے سے پہلے سرٹیفکیٹ کی تجدید کریں۔",
  zatca_onboarding_compliance_failed: "قواعد کی کچھ جانچیں ناکام رہیں۔ زاتکا کے اصل خرابی پیغامات نیچے دکھائے گئے ہیں؛ سپورٹ سے رابطے پر انہیں کاپی کریں۔",
  zatca_sale_clearance_failed_title: "زاتکا کی منظوری ناکام رہی",
  zatca_sale_clearance_failed_helper: "نیا لین دین شروع کریں۔ اس کوشش کا انوائس کاؤنٹر (ICV) استعمال ہو چکا ہے اور دوبارہ استعمال نہیں ہو سکتا۔",
  zatca_sale_clearance_timeout_title: "زاتکا کی منظوری کا وقت ختم ہو گیا",
  zatca_sale_clearance_timeout_helper: "زاتکا سے رابطہ نہیں ہو پا رہا۔ اسی لین دین پر دوبارہ کوشش کریں یا صارف کے لیے سادہ رسید جاری کریں۔",
  retry_clearance: "منظوری کے لیے دوبارہ کوشش کریں",
  clearance: "منظوری",
  reporting: "رپورٹنگ",
  issue_b2c_instead: "اس کے بجائے صارف کی رسید جاری کریں",
  start_new_transaction: "نیا لین دین شروع کریں",
  zatca_invoice_rejected_alert: "زاتکا نے یہ انوائس مسترد کر دی۔",
  response_status: "جواب کی حالت",
  billing_reference: "بل کا حوالہ",
  invoice_hash: "انوائس کا ہیش",
  responded_at: "جواب کا وقت",
  updated_at: "اپ ڈیٹ کا وقت",
  retry_count: "دوبارہ کوششوں کی تعداد",
  next_retry_at: "اگلی کوشش کا وقت",
  compliance_check: "قواعد کی جانچ",
  same_cr_as_main_branch: "مرکزی برانچ جیسا تجارتی رجسٹریشن نمبر؟",
  validate_same_cr_required: "منتخب کریں کہ اس برانچ کا تجارتی رجسٹریشن نمبر وہی ہے یا نہیں۔",
  select_cr_number: "تجارتی رجسٹریشن نمبر منتخب کریں",
  validate_name_or_phone_required: "نام یا فون نمبر درج کرنا ضروری ہے",
  use_existing_branch_zatca: "موجودہ برانچ کی زاتکا تفصیلات استعمال کریں؟",
  validate_use_existing_branch_zatca: "منتخب کریں کہ آپ موجودہ برانچ کی زاتکا تفصیلات دوبارہ استعمال کرنا چاہتے ہیں یا نہیں۔",
  add_new_cr_number: "اس برانچ کے لیے نیا تجارتی رجسٹریشن نمبر شامل کریں",
  onboarded: "رجسٹر شدہ",
  needs_reonboarding: "دوبارہ رجسٹریشن ضروری ہے",
  not_started: "شروع نہیں ہوا",
  in_progress: "جاری ہے",
  zatca_reonboarding_confirm_title: "زاتکا پر دوبارہ رجسٹریشن ضروری ہے",
  zatca_reonboarding_confirm_message: "زاتکا کی کاروباری تفصیلات اپ ڈیٹ کرنے کے بعد قواعد کے مطابق انوائسز جاری کرنے سے پہلے اس برانچ کو دوبارہ رجسٹر کرنا ہو گا۔ کیا آپ آگے بڑھنا چاہتے ہیں؟",
  use_existing_cr_number: "موجودہ تجارتی رجسٹریشن نمبر استعمال کریں",
  select_zatca_cr_profile: "زاتکا تجارتی رجسٹریشن پروفائل منتخب کریں",
  validate_select_zatca_cr_profile: "زاتکا تجارتی رجسٹریشن پروفائل منتخب کریں۔",
  zatca_cr_profile: "زاتکا تجارتی رجسٹریشن پروفائل",
  branch_delete_zatca_history_error: "یہ برانچ حذف نہیں کی جا سکتی کیونکہ اس کی تاریخ میں زاتکا انوائسز موجود ہیں۔",
  requires_reonboarding_at: "دوبارہ رجسٹریشن ضروری ہونے کا وقت",
  stale_reason: "پرانی معلومات کی وجہ",
  zatca_reonboarding_required_title: "زاتکا پر دوبارہ رجسٹریشن ضروری ہے",
  zatca_reonboarding_required_helper: "فروخت کنندہ کا تجارتی رجسٹریشن پروفائل بدل گیا ہے۔ قواعد کے مطابق انوائسز جاری کرنے سے پہلے متعلقہ آلہ دوبارہ رجسٹر کریں۔",
  zatca_reonboarding_required_for_branch: "{{branch}} کو زاتکا پر دوبارہ رجسٹر کرنا ضروری ہے۔ وجہ: {{reason}}۔",
  zatca_status: "زاتکا کی حالت",
  zatca_branch_details: "زاتکا برانچ کی تفصیلات",
  branch_information: "برانچ کی معلومات",
  branch_address: "برانچ کا پتہ",
  branch_address_details: "برانچ کے پتے کی تفصیلات",
  branch_address_details_helper: "انوائسز اور برانچ کی دستاویزات میں استعمال ہونے والا سرکاری پتہ۔",
  zatca_profile_details: "زاتکا پروفائل کی تفصیلات",
  company_id: "کمپنی آئی ڈی",
  profile_completed: "پروفائل مکمل ہے",
  branches_count: "برانچوں کی تعداد",
  linked_branches: "منسلک برانچیں",
  device_information: "آلے کی معلومات",
  zatca_information: "زاتکا کی معلومات",
  technical_information: "تکنیکی معلومات",
  profile_id: "پروفائل آئی ڈی",
  version: "ورژن",
  branch_zatca_profile_details: "برانچ کے زاتکا پروفائل کی تفصیلات",
  active_lock_key: "فعال لاک کلید",
  csr_content: "CSR کا مواد",
  compliance_csid: "قواعد کی جانچ کا CSID",
  production_csid: "اصل ماحول کا CSID",
  seller_information: "فروخت کنندہ کی معلومات",
  invoice_summary: "انوائس کا خلاصہ",
  amount_summary: "رقم کا خلاصہ",
  document_type: "دستاویز کی قسم",
  enter_otp: "تصدیقی کوڈ درج کریں",
  otp: "تصدیقی کوڈ",
  employee: "ملازم",
  owner: "مالک",
  selected: "منتخب",
  download_slip_pdf: "پرچی PDF میں ڈاؤن لوڈ کریں",
  kiosk: "سیلف سروس کیوسک",
  copy_failed: "کاپی نہیں ہو سکا",
  dev_server: "ڈیولپمنٹ سرور",
  qa_server: "جانچ کا سرور",
  anypos_logo: "AnyPOS لوگو",
  qr_code: "کیو آر کوڈ",
  payment_processing: "ادائیگی پر کارروائی جاری ہے",
  success: "کامیابی",
  loading: "لوڈ ہو رہا ہے...",
  payment_type_mada: "ادائیگی کی قسم: مدا",
  payment_type_visa: "ادائیگی کی قسم: ویزا",
  payment_type_mastercard: "ادائیگی کی قسم: ماسٹرکارڈ",
  upload_units_categories_first: "پہلے اکائیاں اور زمرے اپ لوڈ کریں۔",
  failed_to_load_products: "پروڈکٹس لوڈ نہیں ہو سکیں",
  voice_connection_error: "آواز کا رابطہ نہیں ہو سکا۔ دوبارہ کوشش کریں۔",
  voice_session_inactive: "وقفے کے بعد صوتی معاون بند ہو گیا۔ دوبارہ شروع کرنے کے لیے مائیک دبائیں۔",
  voice_session_time_limit: "صوتی معاون کا وقت ختم ہو گیا۔ دوبارہ شروع کرنے کے لیے مائیک دبائیں۔",
  voice_agent_activated: "صوتی معاون فعال ہو گیا! بولنا شروع کریں۔",
  failed_to_start_voice_agent: "صوتی معاون شروع نہیں ہو سکا۔",
  failed_to_start_voice_agent_retry: "صوتی معاون شروع نہیں ہو سکا۔ دوبارہ کوشش کریں۔",
  failed_to_load_order_history: "آرڈرز کی تاریخ لوڈ نہیں ہو سکی",
  order_confirmed: "آرڈر کی تصدیق ہو گئی",
  voice_assistant: "صوتی معاون",
  touch_screen: "ٹچ اسکرین",
  ask_me_to_help_you_order: "آرڈر دینے میں مجھ سے مدد لیں",
  ready: "تیار",
  available_options: "دستیاب اختیارات:",
  report_invoice: "انوائس رپورٹ کریں",
  clear_invoice: "انوائس کی منظوری حاصل کریں",
  zatca_invoice_report_success: "زاتکا انوائس جمع ہو گئی",
  zatca_invoice_report_failed: "زاتکا انوائس جمع نہیں ہو سکی",
  invoice_submitted_to_zatca: "انوائس زاتکا کو جمع کرا دی گئی۔",
  bulk_report_b2c_invoices: "صارفین کی متعدد انوائسز رپورٹ کریں",
  bulk_report_selected_b2c_confirm: "کیا آپ واقعی منتخب کردہ {{count}} صارف انوائسز زاتکا کو رپورٹ کرنا چاہتے ہیں؟",
  bulk_report_all_b2c_confirm: "کوئی انوائس منتخب نہیں ہے۔ اس سے کمپنی کی تمام زیر التوا یا ناکام صارف انوائسز رپورٹ ہوں گی۔ کیا آپ یقینی ہیں؟",
  bulk_report_b2c_success: "زاتکا کو اجتماعی رپورٹنگ بھیج دی گئی",
  bulk_report_b2c_failed: "زاتکا کو اجتماعی رپورٹنگ نہیں بھیجی جا سکی",
  bulk_report_b2c_max_limit: "زیادہ سے زیادہ 500 انوائسز منتخب کی جا سکتی ہیں۔",
  bulk_report_b2c_dispatched_count: "{{count}} انوائسز بھیج دی گئیں۔",
  zatca_temporarily_unavailable: "زاتکا عارضی طور پر دستیاب نہیں",
  select_emoji: "ایموجی منتخب کریں",
  emoji: "ایموجی",
  unexpected_error_description: "غیر متوقع خرابی پیش آئی۔ صفحہ دوبارہ لوڈ کر کے کوشش کریں۔",
  reload_page: "صفحہ دوبارہ لوڈ کریں",
  checkout_total_must_be_greater_than_zero: "کل رقم صفر سے زیادہ ہونی چاہیے۔",
  phone_number_example: "مثلاً +966 5xxxxxxx",
  licenses_used_summary: "استعمال شدہ لائسنس: {{total}} میں سے {{used}}",
  sold: "فروخت شدہ",
  addition: "اضافہ",
  subtraction: "کمی",
  multi_payment_cash: "متعدد ادائیگیوں میں نقد",
  multi_payment_card: "متعدد ادائیگیوں میں کارڈ",
  qr_order: "کیو آر آرڈر",
  notifications: "اطلاعات",
  notification_sound_on: "اطلاع کی آواز آن ہے",
  notification_sound_off: "اطلاع کی آواز بند ہے",
  notification_sound_blocked: "براؤزر نے اطلاع کی آواز روک دی ہے۔ صفحے پر کہیں کلک کریں یا آواز بند کر کے دوبارہ آن کریں۔",
  notification_sound_failed: "اطلاع کی آواز نہیں چل سکی۔ آلے کا والیوم چیک کریں۔",
  mark_all_as_read: "سب کو پڑھا ہوا نشان زد کریں",
  no_notifications: "ابھی کوئی اطلاع نہیں",
  new_pending_qr_order: "نیا زیر التوا کیو آر آرڈر {{orderNumber}}",
  pending_qr_order_notification_details: "میز {{table}} · رقم {{amount}}",
  table_management: "میزوں کا انتظام",
  order_management: "آرڈرز کا انتظام",
  waiter_management: "ویٹر کا انتظام",
  job_management: "کاموں کا انتظام",
  stock_management: "اسٹاک کا انتظام",
  surepay: "شور پے",
  customer_management: "گاہکوں کا انتظام",
  error_in_row: "قطار {{row}} میں خرابی: {{message}}",
  category_name_example: "برگر 🍔",
  transaction_reference: "لین دین کا حوالہ",
  payment_method: "ادائیگی کا طریقہ",
  amount_received: "وصول شدہ رقم",
  remaining: "باقی",
  buyer: "خریدار",
  transaction_code: "لین دین کا کوڈ",
  issue_date: "جاری کرنے کی تاریخ",
  item: "شے",
  unit_price: "فی اکائی قیمت",
  printed_by_anypos: "anypos.ai سے پرنٹ شدہ",
  order_source: "آرڈر کا ذریعہ",
  job_employee: "کام پر مامور ملازم",
  refund_invoice: "رقم واپسی کی انوائس",
  simplified_invoice: "سادہ انوائس",
  tax_invoice: "ٹیکس انوائس",
  simplified_tax_invoice: "سادہ ٹیکس انوائس",
  refund_invoice_no: "رقم واپسی کی انوائس نمبر",
  vat_exempt: "ویلیو ایڈڈ ٹیکس سے مستثنیٰ",
  vat_total: "کل ویلیو ایڈڈ ٹیکس",
  total_taxable_excluding_vat: "ٹیکس کے قابل کل رقم (ویلیو ایڈڈ ٹیکس کے بغیر)",
  total_amount_due: "کل واجب الادا رقم",
  verifying_with_zatca: "زاتکا سے تصدیق جاری ہے…",
  rejected_by_zatca: "زاتکا نے مسترد کر دیا",
  error: "خرابی",
  warning: "انتباہ",
  saudi_arabia: "سعودی عرب",
  website_appearance: "ظاہری شکل",
  website_brand: "برانڈ",
  website_brand_help: "اپنے برانڈ کا رنگ منتخب کریں جو ویب سائٹ پر دکھایا جائے گا",
  website_primary_colour: "بنیادی رنگ",
  website_default_language: "ویب سائٹ کی ابتدائی زبان",
  website_default_language_help: "وہ زبان منتخب کریں جو گاہک ویب سائٹ پہلی بار کھولنے پر دیکھیں گے۔",
  website_language_english: "انگریزی",
  website_language_arabic: "عربی",
  website_in_english: "{{field}} انگریزی میں",
  website_in_arabic: "{{field}} عربی میں",
  website_arabic_only_validation: "صرف عربی حروف استعمال کریں",
  website_save_color: "رنگ محفوظ کریں",
  website_color_saved: "رنگ کامیابی سے محفوظ ہو گیا",
  website_saved: "ویب سائٹ کی ترتیبات کامیابی سے محفوظ ہو گئیں",
  website_banners: "بینرز",
  website_add_banner: "بینر شامل کریں",
  website_edit_banner: "بینر میں ترمیم کریں",
  website_banner_title: "بینر کا عنوان",
  website_banner_title_placeholder: "مثلاً تازہ کھانا آن لائن منگوائیں",
  website_banner_title_required: "بینر کا عنوان ضروری ہے",
  website_banner_label: "لیبل",
  website_banner_label_placeholder: "مثلاً نیا یا مقبول",
  website_banner_description_placeholder: "مختصر تفصیل درج کریں",
  website_background_colour: "پس منظر کا رنگ",
  website_banner_icon: "آئیکن",
  website_banner_image: "بینر کی تصویر",
  website_image_read_error: "منتخب تصویر پڑھی نہیں جا سکی",
  website_about: "تعارف",
  website_section_heading: "حصے کا عنوان",
  website_section_heading_placeholder: "مثلاً ہمارے کاروبار کے بارے میں",
  website_about_text: "کمپنی کا تعارف",
  website_about_text_placeholder: "گاہکوں کو اپنے کاروبار کے بارے میں بتائیں",
  website_highlights: "نمایاں باتیں",
  website_add_highlight: "نمایاں بات شامل کریں",
  website_highlight_number: "نمایاں بات {{number}}",
  website_highlight_placeholder: "اہم خصوصیت یا فائدہ درج کریں",
  phone_number_placeholder: "فون نمبر درج کریں",
  email_placeholder: "ای میل پتہ درج کریں",
  address_placeholder: "کاروباری پتہ درج کریں",
  website_contact: "رابطہ",
  website_working_hours: "کام کے اوقات",
  website_working_hours_help: "ہر دن کے کھلنے اور بند ہونے کا وقت مقرر کریں",
  website_day_sunday: "اتوار",
  website_day_monday: "پیر",
  website_day_tuesday: "منگل",
  website_day_wednesday: "بدھ",
  website_day_thursday: "جمعرات",
  website_day_friday: "جمعہ",
  website_day_saturday: "ہفتہ",
  website_open: "کھلا",
  website_closed: "بند",
  website_to: "سے",
  website_toggle_day: "{{day}} کی دستیابی تبدیل کریں",
  website_open_time_for: "{{day}} کو کھلنے کا وقت",
  website_close_time_for: "{{day}} کو بند ہونے کا وقت",
  website_social: "سوشل میڈیا",
  instagram: "انسٹاگرام",
  tiktok: "ٹک ٹاک",
  facebook: "فیس بک",
  x: "ایکس",
  website_branches: "برانچیں",
  website_menu: "مینو",
  website_builder_sections: "ویب سائٹ بنانے کے حصے",
  website_tip_title: "برانڈ کے رنگ کے لیے مشورہ",
  website_tip_text: "یہاں منتخب رنگ ویب سائٹ کے اہم حصوں، جیسے بٹن، لنکس اور عنوانات پر لگایا جائے گا۔",
  website_hero_banners: "مرکزی بینرز",
  website_hero_banners_help: "ویب سائٹ کے اوپر دلکش بینرز شامل کریں",
  website_no_label: "کوئی لیبل نہیں",
  website_no_banners: "ابھی کوئی بینر شامل نہیں کیا گیا",
  website_about_section: "تعارفی حصہ",
  website_about_help: "گاہکوں کو اپنے کاروبار، پروڈکٹس اور خدمات کے بارے میں بتائیں",
  website_highlights_help: "کاروبار کی اہم خصوصیات یا فوائد شامل کریں",
  website_stats: "اعداد و شمار (نمایاں کارڈز میں دکھائے جاتے ہیں)",
  website_stats_help: "وہ اعداد اور عنوانات شامل کریں جو آپ اپنے کاروبار کے بارے میں نمایاں کرنا چاہتے ہیں",
  website_stat_value: "عدد {{number}}",
  website_stat_label: "عنوان {{number}}",
  website_stat_value_placeholder: "مثلاً 50 ہزار سے زیادہ",
  website_stat_label_placeholder: "مثلاً مطمئن گاہک",
  website_contact_details: "رابطے کی معلومات",
  website_social_help: "ویب سائٹ پر دکھانے کے لیے سوشل میڈیا لنکس شامل کریں",
  website_all_branches: "تمام برانچیں",
  website_branch_visibility_help: "منتخب کریں کہ ویب سائٹ پر کون سی برانچیں نظر آئیں",
  website_show_all_branches: "سب دکھائیں",
  website_hide_all_branches: "سب چھپائیں",
  website_online_branches: "آن لائن برانچیں",
  website_manage_branches: "برانچوں کا انتظام",
  website_branches_help: "ویب سائٹ پر دکھانے کے لیے برانچیں منتخب کریں",
  website_no_branches: "کوئی برانچ نہیں ملی",
  website_online_orders: "آن لائن آرڈرز",
  website_menu_visibility: "مینو کی نمائش",
  website_menu_help: "آن لائن مینو دیکھیں اور منتخب کریں کہ گاہک کون سی پروڈکٹس دیکھ سکیں۔",
  website_menu_categories: "مینو کے زمرے",
  website_menu_visibility_help: "ہر پروڈکٹ کا سوئچ استعمال کر کے ویب سائٹ پر اس کی نمائش طے کریں۔",
  website_show_category: "زمرہ ویب سائٹ پر دکھائیں",
  website_hide_category: "زمرہ ویب سائٹ سے چھپائیں",
  website_toggle_category: "{{category}} کی ویب سائٹ پر نمائش تبدیل کریں",
  website_all_products: "تمام پروڈکٹس",
  website_show_all_products: "سب دکھائیں",
  website_hide_all_products: "سب چھپائیں",
  website_grid_view: "گرڈ میں دکھائیں",
  website_list_view: "فہرست میں دکھائیں",
  website_product_visibility_help: "منتخب کریں کہ آن لائن دکان پر کون سی پروڈکٹس نظر آئیں۔",
  website_visible: "نظر آ رہا ہے",
  website_hidden: "چھپا ہوا",
  website_visible_of_total: "{{total}} میں سے {{count}} نظر آ رہے ہیں",
  website_manage_products: "پروڈکٹس کا انتظام",
  website_products: "پروڈکٹس",
  website_no_products: "کوئی پروڈکٹ نہیں ملی",
  website_no_categories: "کوئی زمرہ نہیں ملا",
  website_manage_menu: "مینو کا انتظام",
  website_enabled: "فعال",
  website_disabled: "غیر فعال",
  website_on: "آن",
  website_off: "آف",
  public_website_search_menu: "مینو میں تلاش کریں…",
  public_website_clear_search: "تلاش صاف کریں",
  public_website_sold_out: "فروخت ہو چکا",
  public_website_no_menu_items: "مینو میں کوئی شے نہیں ملی",
  public_website_try_another_search: "دوسری تلاش آزمائیں۔",
  public_website_our_locations: "ہمارے مقامات",
  public_website_visit_branches: "ہماری برانچوں میں آئیں",
  public_website_about_us: "ہمارے بارے میں",
  public_website_quick_links: "فوری لنکس",
  public_website_store_navigation: "دکان کے صفحات",
  public_website_open_navigation_menu: "نیویگیشن مینو کھولیں",
  public_website_close_navigation_menu: "نیویگیشن مینو بند کریں",
  public_website_use_dark_mode: "ڈارک موڈ استعمال کریں",
  public_website_use_light_mode: "لائٹ موڈ استعمال کریں",
  public_website_promotions: "پیشکشیں",
  public_website_previous_banner: "پچھلا بینر",
  public_website_next_banner: "اگلا بینر",
  public_website_show_banner: "بینر دکھائیں",
  public_website_online_store: "آن لائن دکان",
  public_website_powered_by: "ویب سائٹ کی معاونت",
  public_website_get_free_website_with: "مفت ویب سائٹ حاصل کریں",
  choose_business: "کاروبار منتخب کریں",
  choose_business_description: "وہ کاروباری اکاؤنٹ منتخب کریں جس کے ساتھ آگے بڑھنا چاہتے ہیں۔",
  business_not_found: "کاروبار نہیں ملا",
  business_not_found_description: "اس کاروبار کا یو آر ایل موجود نہیں ہے۔ پتہ چیک کریں یا مرکزی پورٹل استعمال کریں۔",
  go_to_generic_portal: "مرکزی پورٹل پر جائیں",
  invalid_credentials: "فون نمبر یا پاس ورڈ غلط ہے۔",
  store_url: "دکان کا یو آر ایل",
  checking_store_url: "دستیابی چیک کی جا رہی ہے…",
  store_url_available: "یہ یو آر ایل دستیاب ہے۔",
  store_url_taken: "یہ یو آر ایل پہلے سے استعمال میں ہے۔",
  store_url_invalid: "درست یو آر ایل درج کریں۔",
  store_url_suggestions: "تجاویز",
  store_url_preview: "آپ کی دکان کا یو آر ایل",
  store_url_required: "دکان کا یو آر ایل درج کرنا ضروری ہے۔",
};

export default trans_ur;
